import { useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { API_DOMAIN } from './config/config';

export const useSocket = (user_id) => {
  const socketRef = useRef(null);

  useEffect(() => {
    const url = API_DOMAIN;
    const options = {
      transports: ["websocket"], // ép dùng websocket
      path: '/v1/modv2-notification'
    };
    socketRef.current = io(url, options);
    socketRef.current.emit("join", { rid: user_id });
    console.log('Socket connected - '+ user_id);
    return () => {
      socketRef.current.disconnect();
    };
  }, [user_id]);

  return socketRef.current;
};